export default __webpack_public_path__ + "static/media/snaps.f05d4816.webp";